'use strict'

/**
 * Arredondamento bancario (ROUND_HALF_EVEN / Banker's Rounding), o mesmo
 * usado pelo Sistema Nacional NFS-e (Sefin Nacional) e replicado no backend
 * em FiscalCalculationService.roundHalfEvenDivision (gspro12-api). Extraido
 * de notaAutomatica.vue (ticket #274) para um modulo puro, sem dependencia
 * do Vue, que possa ser exercitado diretamente pelos testes unitarios -
 * testar uma copia da funcao, e nao a funcao real, foi exatamente o que
 * deixou passar o bug original (ticket #260/#346).
 */
function roundHalfEvenDivision(numerador, denominador) {
  const quociente = Math.floor(numerador / denominador)
  const resto = numerador - quociente * denominador
  const dobroResto = resto * 2
  if (dobroResto > denominador) return quociente + 1
  if (dobroResto < denominador) return quociente
  return quociente % 2 === 0 ? quociente : quociente + 1
}

module.exports = { roundHalfEvenDivision }
